<template>
  <v-container>
    <slot />
  </v-container>
</template>

<script>
export default {};
</script>
